import React, { useState, useEffect } from "react";
import "./Workflow Template.css";
import CreateWorkflowTemplate from "./Workflow Template Contents/Workflow Template Creation";
import WorkflowTemplateList from "./Workflow Template Contents/Workflow Template List";
import WorkflowTemplateServiceController from "../../Controllers/WorkflowTemplateservice";

const WorkflowTemplate = ({ handleSubflowCanvasClick, isSubflow, Json, createEvent, toolTipData }) => {
  console.log("in workflow tab and tooltipData ", toolTipData);

  const [createTemplate, setCreateTemplate] = useState(false);
  const [isWorkflow, setIsWorkflow] = useState(isSubflow);
  const [json, setJson] = useState(Json);
  const [workflowTempId, setWorkflowTempId] = useState(0);
  const [isEditWorkflow, setIsEditWorkflow] = useState(false);
  const [workflowTempName, setWorkflowTempName] = useState('');
  const [workflowTempReqBody, setWorkflowTempReqBody] = useState({});
  const [addFiltersData, setAddFiltersData] = useState([]);
  const [isCloneWorkflow, setIsCloneWorkflow] = useState(false);

  //Function called on clicking the create button in workflow template list
  const handleClick = () => {
    setJson({
      "nodes": [],
      "edges": [],
      "dropdownData": {
        "client": { label: "--select--", value: "--select--", dropdownId: "0" },
        "department": { label: "--select--", value: "--select--", dropdownId: "0" },
        "workflowName": { label: "--select--", value: "--select--", dropdownId: "0" },
        "level": { label: "--select--", value: "--select--", dropdownId: "0" },
      }
    });
    setCreateTemplate(true);
    setWorkflowTempId(0);
    setIsEditWorkflow(false);
    setIsCloneWorkflow(false);
    setWorkflowTempName('');
    setWorkflowTempReqBody([]);
  };

  const displayTemplateData = (templateData, id, requestBody, subflowTempName, addFilters) => {
    console.log("in display tep data", id);
    setJson(templateData);
    setWorkflowTempId(id);
    setWorkflowTempReqBody(requestBody);
    setWorkflowTempName(subflowTempName);
    setAddFiltersData(addFilters);
    setIsEditWorkflow(true);
    setIsCloneWorkflow(false);
    setCreateTemplate(true);
  }

  const displayCloneTemplateData = (templateData, id, requestBody, subflowTempName, addFilters) => {
    console.log("in display tep data", id);
    setJson(templateData);
    setWorkflowTempId(id);
    setWorkflowTempReqBody(requestBody);
    setWorkflowTempName(subflowTempName);
    setAddFiltersData(addFilters);
    setIsEditWorkflow(false);
    setIsCloneWorkflow(true);
    setCreateTemplate(true);
  }
  //Function called on clicking the back buttion in workflow template creation
  const handleBackClick = () => {
    setCreateTemplate(false);
    setJson({
      "nodes": [],
      "edges": [],
      "dropdownData": {
        "client": { label: "--select--", value: "--select--", dropdownId: "0" },
        "department": { label: "--select--", value: "--select--", dropdownId: "0" },
        "workflowName": { label: "--select--", value: "--select--", dropdownId: "0" },
        "level": { label: "--select--", value: "--select--", dropdownId: "0" },
      }
    });
    setIsEditWorkflow(false);
  };

  

  //variable createTemplate is managed based on the click events above to decide the content of the selected tab
  return !createTemplate ? (
    <>
      <WorkflowTemplateList
        onHandleClick={handleClick}
        displayTemplateData={displayTemplateData}
        displayCloneTemplateData={displayCloneTemplateData}
        toolTipData={toolTipData}
      />
    </>
  ) : (
    <>
      <CreateWorkflowTemplate
        onBackClick={handleBackClick}
        handleSubflowCanvasClick={handleSubflowCanvasClick}
        isSubflow={isWorkflow}
        json={json}
        workflowName={Json.dropdownData.workflowName.label}
        level={Json.dropdownData.level.label}
        workflowTempId={workflowTempId}
        workflowReqBody={workflowTempReqBody}
        workflowTempName={workflowTempName}
        isEditWorkflow={isEditWorkflow}
        isCloneWorkflow={isCloneWorkflow}
        addFilters={addFiltersData}
        createEvent={createEvent}
      />
    </>
  );
};

export default WorkflowTemplate;
